import {NgModule} from '@angular/core';
import { EvenNumbersMaxDirective } from './even-numbers-Max.directive';
import { DecimalNumbersMaxDirective } from './decimal-numbers-Max.directive';
import {DateFieldDirective} from './dateField.directive';
import {RoundPipe} from '@src/app/roundDownPipe';

@NgModule({
  exports: [
    EvenNumbersMaxDirective,
    DecimalNumbersMaxDirective,
    DateFieldDirective,
    RoundPipe,
  ],
  declarations: [
    EvenNumbersMaxDirective,
    DecimalNumbersMaxDirective,
    DateFieldDirective,
    RoundPipe
  ]
})
export class SharedModule {}
